import * as React from 'react';
import { DropdownContext } from './Dropdown';
const DropdownTrigger = /*#__PURE__*/React.memo(_ref => {
  let {
    children,
    ...props
  } = _ref;
  const ctx = React.useContext(DropdownContext);
  return children(ctx);
});
DropdownTrigger.propTypes = {};
DropdownTrigger.defaultProps = {};
DropdownTrigger.displayName = 'DropdownTrigger';
export default DropdownTrigger;